var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemWarning = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M12 3c.712 0 1.424.332 1.793.997l3.825 6.888 4.168 7.505c.666 1.199-.303 2.61-1.793 2.61H4.007c-1.49 0-2.459-1.411-1.793-2.61l4.168-7.505 3.825-6.888C10.576 3.332 11.288 3 12 3m0 2a.2.2 0 0 0-.066.009l-3.803 6.846L4.163 19h15.674l-3.968-7.145-3.803-6.846A.2.2 0 0 0 12 5m0 10a1 1 0 1 1 0 2 1 1 0 1 1 0-2m0-6a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1"
})));
export default SvgGemWarning;